import { Shield, Wallet, ArrowRight } from "lucide-react";
import { AffiliateLink } from "./AffiliateLink";
import { getAffiliateLink } from "@/lib/affiliate-registry";
import { type AffiliateId } from "@/config/affiliateLinks";

interface MiniCta {
  id: AffiliateId;
  title: string;
  text: string;
  cta: string;
  microcopy: string;
  icon: React.ReactNode;
  accent: string;
}

const CTAS: MiniCta[] = [
  {
    id: "tjenestetorvetForsikring",
    title: "Forsikring til din elbil",
    text: "Sammenlign tilbud fra flere selskaber på 2 minutter.",
    cta: "Få 3 forsikringstilbud",
    microcopy: "Gratis og uforpligtende",
    icon: <Shield className="w-5 h-5" />,
    accent: "from-primary/15 to-primary/5 text-primary",
  },
  {
    id: "leasyMinilaan",
    title: "Lån til din nye elbil",
    text: "Beregn månedlig ydelse og se hvad du kan låne.",
    cta: "Beregn månedlig ydelse",
    microcopy: "Svar med det samme",
    icon: <Wallet className="w-5 h-5" />,
    accent: "from-accent/20 to-accent/5 text-accent-foreground",
  },
];

export function CarDetailAffiliateBlock() {
  const available = CTAS.filter((c) => !!getAffiliateLink(c.id));
  if (available.length === 0) return null;

  return (
    <section
      aria-label="Annoncer fra vores partnere"
      className="rounded-none border-0 bg-transparent p-0 sm:rounded-xl"
    >
      <div className="mb-3 flex items-center justify-between gap-2 sm:mb-4">
        <div>
          <span className="inline-block text-[10px] font-bold uppercase tracking-wider text-primary bg-primary/10 px-2 py-0.5 rounded-full mb-2">
            Annonce
          </span>
          <h2 className="font-display text-[19px] font-bold sm:text-xl">Klar til at tage skridtet?</h2>
          <p className="text-sm text-muted-foreground mt-0.5">
            Sammenlign forsikring, finansiering og ladeboks fra vores partnere.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
        {available.map((c) => (
          <div
            key={c.id}
            className="group relative flex flex-col gap-2.5 rounded-xl border border-border bg-card p-3.5 transition-all hover:border-primary/40 hover:shadow-md"
          >
            <div className={`inline-flex w-10 h-10 items-center justify-center rounded-lg bg-gradient-to-br ${c.accent}`}>
              {c.icon}
            </div>
            <div>
              <h3 className="font-semibold text-base leading-tight">{c.title}</h3>
              <p className="text-xs text-muted-foreground leading-relaxed mt-1">{c.text}</p>
            </div>
            <div className="mt-auto space-y-1.5">
              <AffiliateLink
                affiliateId={c.id}
                variant="button"
                placement="car-detail-block"
                className="w-full justify-center group/btn"
              >
                <span>{c.cta}</span>
                <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover/btn:translate-x-0.5" aria-hidden="true" />
              </AffiliateLink>
              <p className="relative z-10 text-[11px] text-center text-muted-foreground">{c.microcopy}</p>
            </div>
          </div>
        ))}

      </div>

      <p className="mt-3 text-center text-[11px] leading-snug text-muted-foreground">
        Affiliate-links. Min Nye Elbil kan modtage kommission, hvis du klikker videre – det påvirker ikke prisen for dig.
      </p>
    </section>
  );
}
